import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
  } from "recharts";
import { useTranslation } from "src/pages";
  
  export const RouteDeviationTrendChart = ({
    color = "#f59e0b",   // Orange par défaut (alerte modérée)
    period = "jour",      // "jour" | "semaine" | "mois"
    dayFactor = 1
  }) => {
  
    const dataByPeriod = {
      jour: [
        { label: "00h", deviations: 2 },
        { label: "04h", deviations: 3 },
        { label: "08h", deviations: 8 },
        { label: "12h", deviations: 12 },
        { label: "16h", deviations: 10 },
        { label: "20h", deviations: 5 },
      ],
      
      semaine: [
        { label: "Lun", deviations: 15 },
        { label: "Mar", deviations: 18 },
        { label: "Mer", deviations: 22 },
        { label: "Jeu", deviations: 20 },
        { label: "Ven", deviations: 28 },
        { label: "Sam", deviations: 17 },
        { label: "Dim", deviations: 12 },
      ],
      mois: [
        { label: "S1", deviations: 70 },
        { label: "S2", deviations: 85 },
        { label: "S3", deviations: 78 },
        { label: "S4", deviations: 92 },
      ],
    };
  
    const data = (dataByPeriod[period] || []).map((item) => ({
      ...item,
      deviations: Math.max(0, Math.round(item.deviations * dayFactor)),
    }));
  const { t } = useTranslation ();
    return (
      <div className="glass-card p-5 animate-fade-in">
        {/* <h2 className="text-lg font-semibold mb-4">
          Évolution du non-respect des itinéraires prévus
        </h2> */}
  
        <div className="h-72 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data}>
              <defs>
                <linearGradient id="deviationGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.3} />
                  <stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
  
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                stroke="hsl(var(--border))"
              />
  
              <XAxis
                dataKey="label"
                axisLine={false}
                tickLine={false}
                tick={{ fill: "#94a3b8", fontSize: 12 }}
              />
  
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fill: "#94a3b8", fontSize: 12 }}
                label={{
                  value: t("LEWOOMINING.routes_number"),
                  angle: -90,
                  position: "insideLeft",
                  offset: 10,
                }}
              />
  
              <Tooltip
                contentStyle={{
                  background: "hsl(var(--card))",
                  borderRadius: "10px",
                  border: "1px solid hsl(var(--border))",
                }}
                formatter={(value) => `${value} trajets`}
                labelFormatter={(label) => `Période : ${label}`}
              />
  
              <Area
                type="monotone"
                dataKey="deviations"
                stroke={color}
                strokeWidth={3}
                fill="url(#deviationGradient)"
                dot={{ r: 4 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };
  
